"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseAndCalculateStakeholderRewards = exports.parseStakeholderAddresses = exports.calculateStakeholderRewards = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const addressParsing_1 = require("./addressParsing");
const likerIdsAddresses_1 = require("./likerIdsAddresses");
async function getLikeWalletFromId(id, _temp) {
  let {
    LIKE_CO_API_ROOT = 'https://api.like.co'
  } = _temp === void 0 ? {} : _temp;
  let likeWallet = null;
  if (!id) return null;
  const match = id.match(/^https:\/\/like\.co\/([a-z0-9_-]{6,20})/);
  if (match) {
    const [, likerId] = match;
    if (likerId) likeWallet = await (0, likerIdsAddresses_1.getLikeWalletByLikerId)(likerId, {
      LIKE_CO_API_ROOT
    });
  } else {
    likeWallet = (0, addressParsing_1.getLikeWalletAddress)(id);
  }
  return likeWallet;
}
function calculateStakeholderRewards(iscnData, defaultWallet, _temp2) {
  let {
    totalAmount = '1',
    precision = 9
  } = _temp2 === void 0 ? {} : _temp2;
  const LIKEMap = new Map();
  const {
    stakeholders
  } = iscnData;
  if (stakeholders === null || stakeholders === void 0 ? void 0 : stakeholders.length) {
    const likeWallets = stakeholders.map(stakeholder => {
      const id = stakeholder.entity['@id'];
      if (id && (0, addressParsing_1.isValidAddress)(id)) {
        return (0, addressParsing_1.changeAddressPrefix)(id, 'like');
      }
      return null;
    });
    const weightMap = new Map();
    likeWallets.forEach((likeWallet, i) => {
      if (likeWallet) {
        let weight = new bignumber_js_1.default(stakeholders[i].rewardProportion);
        if (weightMap.has(likeWallet)) {
          weight = weightMap.get(likeWallet).weight.plus(weight);
        }
        weightMap.set(likeWallet, {
          weight
        });
      }
    });
    const totalWeight = [...weightMap.values()].map(_ref => {
      let {
        weight
      } = _ref;
      return weight;
    }).reduce((prev, curr) => prev.plus(curr), new bignumber_js_1.default(0));
    weightMap.forEach((_ref2, address) => {
      let {
        weight
      } = _ref2;
      const amount = new bignumber_js_1.default(weight.times(totalAmount).div(totalWeight).toFixed(precision, bignumber_js_1.default.ROUND_DOWN));
      if (amount && amount.gt(0)) LIKEMap.set(address, {
        amount: amount.toFixed()
      });
    });
  }
  if (LIKEMap.size === 0) {
    const amount = new bignumber_js_1.default(totalAmount).toFixed(precision, bignumber_js_1.default.ROUND_DOWN);
    LIKEMap.set(defaultWallet, {
      amount: new bignumber_js_1.default(amount).toFixed()
    });
  }
  return LIKEMap;
}
exports.calculateStakeholderRewards = calculateStakeholderRewards;
async function parseStakeholderAddresses(iscnData, _temp3) {
  let {
    LIKE_CO_API_ROOT = 'https://api.like.co'
  } = _temp3 === void 0 ? {} : _temp3;
  const parsedIscnData = iscnData;
  const {
    stakeholders
  } = iscnData;
  let parsedStakeholders;
  if (stakeholders === null || stakeholders === void 0 ? void 0 : stakeholders.length) {
    parsedStakeholders = await Promise.all(stakeholders.map(async stakeholder => {
      const parsedStakeholder = stakeholder;
      const id = stakeholder.entity['@id'];
      if (id) {
        const likeWallet = await getLikeWalletFromId(id, {
          LIKE_CO_API_ROOT
        });
        parsedStakeholder.entity['@id'] = likeWallet;
      }
      return parsedStakeholder;
    }));
  }
  parsedIscnData.stakeholders = parsedStakeholders;
  return parsedIscnData;
}
exports.parseStakeholderAddresses = parseStakeholderAddresses;
async function parseAndCalculateStakeholderRewards(iscnData, defaultWallet, _temp4) {
  let {
    LIKE_CO_API_ROOT = 'https://api.like.co',
    totalAmount = '1',
    precision = 9
  } = _temp4 === void 0 ? {} : _temp4;
  const parsedIscnData = await parseStakeholderAddresses(iscnData, {
    LIKE_CO_API_ROOT
  });
  const map = calculateStakeholderRewards(parsedIscnData, defaultWallet, {
    totalAmount,
    precision
  });
  return map;
}
exports.parseAndCalculateStakeholderRewards = parseAndCalculateStakeholderRewards;